import { useEffect, useState } from "react";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useResponsabilidadeOrgao = (cdUsuario) => {
  const [responsabilidadeOrgao, setResponsabilidadeOrgao] = useState("");
  const { request, data } = useApiClient();

  useEffect(() => {
    const parametros = { cdUsuario };

    if (cdUsuario) {
      request(apiRoutes.fiscalizacao.ordemservico.responsabilidadeOrgao, parametros);
    }
  }, [cdUsuario, request]);

  useEffect(() => {
    if (data?.result.length > 0) {
      setResponsabilidadeOrgao(data?.result[0].txTpResponsabilidadeOrgao);
    }
  }, [data?.result]);

  return { responsabilidadeOrgao };
};

export default useResponsabilidadeOrgao;
